import { render } from "./Register.vue?vue&type=template&id=67d2bbd0&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=67d2bbd0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67d2bbd0"

export default script